import throttle from 'lodash.throttle';
import { getBreakpoint, breakpoints } from './breakpoints';

/**
 * Stores the currently active breakpoint.
 *
 * @type {number}
 */
let currentBreakpoint = 0;

/**
 * Emits an event on the window, whenever the breakpoint changes.
 */
const emitBreakPointEvent = () => {
    const breakpoint = getBreakpoint();

    if (breakpoint === currentBreakpoint) {
        return;
    }

    currentBreakpoint = breakpoint;
    const breakPointEvent = new CustomEvent('breakpoint', {
        detail: {
            breakpoint: currentBreakpoint,
        },
    });

    window.dispatchEvent(breakPointEvent);
};

(() => {
    currentBreakpoint = getBreakpoint();

    window.addEventListener('resize', throttle(emitBreakPointEvent, 100));
    window.addEventListener('orientationchange', throttle(emitBreakPointEvent, 100));
})();
